<template>
  <div class="sort-button">
    <div class="sort-button__actions" v-if="flag">
      <div class="sort-button__arrow sort-button__top">
        <svg
          width="9"
          height="5"
          viewBox="0 0 9 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.34131 3.55566L3.93976 0.957215C4.33028 0.566691 4.96345 0.566691 5.35397 0.957215L7.95242 3.55566"
            stroke="#B9C4D8"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="sort-button__arrow sort-button__bottom">
        <svg
          width="9"
          height="5"
          viewBox="0 0 9 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.34131 1.44434L3.93976 4.04278C4.33028 4.43331 4.96345 4.43331 5.35397 4.04278L7.95242 1.44434"
            stroke="#B9C4D8"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
    <div class="sort-button__actions" v-else>
      <div
        class="sort-button__arrow sort-button__top"
        v-if="!dir || dir === 'DESC'"
      >
        <svg
          width="9"
          height="5"
          viewBox="0 0 9 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.34131 3.55566L3.93976 0.957215C4.33028 0.566691 4.96345 0.566691 5.35397 0.957215L7.95242 3.55566"
            stroke="#B9C4D8"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div
        class="sort-button__arrow sort-button__bottom"
        v-if="!dir || dir === 'ASC'"
      >
        <svg
          width="9"
          height="5"
          viewBox="0 0 9 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.34131 1.44434L3.93976 4.04278C4.33028 4.43331 4.96345 4.43331 5.35397 4.04278L7.95242 1.44434"
            stroke="#B9C4D8"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortButton',
  props: {
    dir: {
      type: String,
      default: null,
    },

    flag: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.sort-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;

    & + & {
      margin-top: 2px;
    }
  }
}
</style>
